// A visitor's page URL as a link target, or null when it must not be one.
//
// Page URLs arrive from the visitor's own widget (`visitor:page`) and are
// stored as sent, so a hostile visitor can report `javascript:…` — React only
// warns about such hrefs, it doesn't block them, and a click would run script
// in the dashboard's origin. Only real http(s) pages become links.

export function pageHref(url: string): string | null {
  try {
    const parsed = new URL(url.trim());
    return parsed.protocol === 'http:' || parsed.protocol === 'https:' ? parsed.href : null;
  } catch {
    return null;
  }
}
